
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu"
import { cn } from "@/lib/utils"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { useIsMobile } from "@/hooks/use-mobile"
import { Menu } from "lucide-react"
import { useState } from "react"
import { useLanguage } from "../contexts/LanguageContext"
import { Button } from "./ui/button"

export function MainNav() {
  const isMobile = useIsMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToOrderForm = () => {
    // Close the mobile menu if it's open
    setIsMenuOpen(false);
    
    // If we're not on the homepage, navigate there first
    if (location.pathname !== '/') {
      navigate('/');
      // Use setTimeout to allow navigation to complete before scrolling
      setTimeout(() => {
        const orderForm = document.getElementById('order-form');
        if (orderForm) {
          orderForm.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Already on homepage, just scroll
      const orderForm = document.getElementById('order-form');
      if (orderForm) {
        orderForm.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const navItems = [
    { to: "/", label: language === 'sv' ? "Hem" : "Home" },
    { to: "/products", label: language === 'sv' ? "Produkter" : "Products" },
    { to: "/about", label: language === 'sv' ? "Om oss" : "About us" },
    { to: "/vessels#vessels-hero", label: language === 'sv' ? "Våra Fartyg" : "Our Vessels" },
    { label: language === 'sv' ? "Beställningar" : "Orders", onClick: scrollToOrderForm, isButton: true },
    { to: "/privacy-policy", label: language === 'sv' ? "Integritetspolicy" : "Privacy Policy" }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-[200]">
      <div className="w-full">
        <div className="flex justify-end items-center py-4 px-4">
          <div className="flex items-center gap-2">
            {/* Language Selector */}
            <Button
              variant="secondary"
              size="sm"
              onClick={toggleLanguage}
              className="bg-black/30 text-white hover:bg-black/50 backdrop-blur-sm border-0 h-10 w-10 p-0 rounded-full"
            >
              {language === 'sv' ? 'EN' : 'SV'}
            </Button>

            {/* Hamburger Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white hover:text-white/80 transition-colors p-2 bg-black/30 rounded-full backdrop-blur-sm h-10 w-10 flex items-center justify-center"
              aria-label="Menu"
            >
              <Menu size={20} />
            </button>
          </div>

          {/* Dropdown Menu */}
          {isMenuOpen && (
            <div className="absolute top-full right-4 mt-2 w-56 bg-black/80 backdrop-blur-md shadow-lg py-2 rounded-lg animate-fade-down">
              {navItems.map((item, index) => (
                item.isButton ? (
                  <button
                    key={index}
                    onClick={item.onClick}
                    className="w-full text-left px-4 py-3 text-white hover:bg-white/10 transition-colors text-sm"
                  >
                    {item.label}
                  </button>
                ) : (
                  <Link
                    key={index}
                    to={item.to}
                    onClick={() => {
                      if (item.onClick) item.onClick();
                      else setIsMenuOpen(false);
                    }}
                    className="block px-4 py-3 text-white hover:bg-white/10 transition-colors text-sm"
                  >
                    {item.label}
                  </Link>
                )
              ))}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
